<template>
  <div class="index-button">
    <div style="width: 80%;display: flex;justify-content: space-between">
      <div class="left">
        <div>友情链接：
          <span v-for="item in linkList" @click="goPage(item.url)" ><span style="cursor: pointer">{{ item.urlName }}</span>  |  </span>
        </div>
        <div style="margin-top: 30px">网站备案/许可证号：京ICP备18056520号-2</div>
      </div>
      <div class="right">
        <img src="static/qrcode.png" alt=""/>
        <img src="static/logo.png" alt="" style="margin-left: 20px">
        <img src="static/shiye.png" alt="" style="margin-left: 20px">
      </div>
    </div>

  </div>
</template>

<script>
import { queryUrlList } from "@/api";
export default {
  name: "PageHeaders",
  props: {},
  components: {},
  data() {
    return {
      linkList: []
    }
  },
  // 进入加载，Dom未编译前
  created() {
  },
  // 进入加载，Dom编译完成后
  mounted() {
    this.getLink()
  },
  // 离开加载
  destroyed() {

  },
  // 监听事件
  watch: {},
  // 计算事件
  // 计算事件
  computed: {
  },
  // 方法盒子
  methods: {
    goPage(url){
      window.open(url);
    },
    getLink(){
      let data = {
        page: {
          current: 1,
          size: 100,
        },
      }
      queryUrlList(data).then(res => {
        this.linkList = res.obj.records
      })
    }
  }
}
</script>

<style scoped lang="scss">
.index-button {
  width: 100%;
  height: 186px;
  background: #F3F3F3;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  z-index: 6;
  .left{
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: flex-start;
    font-size: 14px;
    color: #787878;
    width: 50%;
  }
  .right{
    display: flex;
    align-items: center;
    justify-content: center;
  }
}
</style>
